import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component } from "@angular/core";

import { FooterComponent } from "../../components/common/footer/footer";
import { LoaderComponent } from "../../components/common/loader/loader";

@Component({
  selector: "page-login",
  templateUrl: "login.html",
  styleUrls: ["../../components/common/navigation/navigation.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FooterComponent, LoaderComponent, TranslatePipe],
})
export class LoginPage {}
